export default __webpack_public_path__ + "static/media/heart.988439c8.png";